import { ZipCodeBox } from '@apply/components';
import { useCustomPaymentAddressZip } from '../../../../../fields/CustomPaymentFields';

interface ZipCodeProps {
    customPaymentId: string;
    required?: boolean;
    readOnly?: boolean;
    isReview?: boolean;
    validator?: React.ReactNode;
}

export const ZipCode: React.FC<ZipCodeProps> = ({ customPaymentId, required = false, validator }) => {
    const label = 'Zip Code';
    const [zipCode, set_zipCode] = useCustomPaymentAddressZip(customPaymentId);
    return (
        <>
            <ZipCodeBox
                id='customPaymentZipCode'
                value={zipCode}
                onChange={(value) => set_zipCode(value)}
                label={label}
                placeholder='01234'
                required={required}
                width={'100%'}
                validator={validator}
            />
        </>
    );
};
